import React from 'react';
import { FormGroup } from 'reactstrap';
import { InputColContainer, StyledLabel } from '../shared/Inputs.styles';

/**
 * Evita TextInputContainer do Bit (StyledTextInputContainer): em ≤800px o label
 * vai para position:absolute e o layout do login no mobile quebra.
 */
const FieldContainer = ({ label, name, children, errorMessage }) => (
  <div className="login-form-field-stack">
    <FormGroup style={{ marginBottom: 0, backgroundColor: 'transparent' }}>
      <StyledLabel
        htmlFor={name}
        style={{ marginBottom: 6, color: 'rgba(246, 248, 248, 0.92)' }}
      >
        {label}
      </StyledLabel>
      <InputColContainer underlinecolor="input_underline_default_color">
        {children}
      </InputColContainer>
      {errorMessage}
    </FormGroup>
  </div>
);

export default FieldContainer;
